import Interaction from "../../../models/interactions/Interaction";
import { LisaMessage } from "../../../models/interactions/LisaMessage";
import SequenceLocalizedVariableInputField from "../components/SequenceLocalizedVariableInputField";

export default function LisaMessageNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const lm = props.interaction as LisaMessage;

  return (
    <div className="w-full h-full">
      <SequenceLocalizedVariableInputField
        label="Message"
        placeholder="Message"
        localizationKey={lm.message}
      />
    </div>
  );
}
